import { useQuery } from "@tanstack/react-query";
import { fetchOwnStaffPayMonth, shouldRetryStaffPayRequest, STAFF_PAY_QUERY_KEY } from "./staffPayApi";

type UseOwnStaffPayParameters = {
    viewerId: string | undefined;
    selectedYear: number;
    selectedMonth: number;
    enabled: boolean;
};

export const useOwnStaffPay = ({ viewerId, selectedYear, selectedMonth, enabled }: UseOwnStaffPayParameters) => {
    const apiMonth = selectedMonth + 1;
    const ownStaffPayQuery = useQuery({
        queryKey: [STAFF_PAY_QUERY_KEY, "month", viewerId, selectedYear, apiMonth],
        queryFn: () => fetchOwnStaffPayMonth({ year: selectedYear, month: apiMonth }),
        enabled: enabled && Boolean(viewerId),
        retry: shouldRetryStaffPayRequest,
        refetchOnWindowFocus: false,
    });
    return ownStaffPayQuery;
};
